var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var ButtonStyle = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    align-items: center;\n    padding: 0.8rem;\n    text-decoration: none;\n    text-align: center;\n    border: 1px solid #007bc7;\n    border-radius: 4px;\n    cursor: pointer;\n    line-height: 1;\n    white-space: nowrap;\n    background-color: #fff;\n    color: #000;\n"], ["\n    display: inline-flex;\n    align-items: center;\n    padding: 0.8rem;\n    text-decoration: none;\n    text-align: center;\n    border: 1px solid #007bc7;\n    border-radius: 4px;\n    cursor: pointer;\n    line-height: 1;\n    white-space: nowrap;\n    background-color: #fff;\n    color: #000;\n"])));
export var Button = function (_a) {
    var children = _a.children, onClick = _a.onClick;
    var handleClick = function (e) {
        onClick();
    };
    return (_jsx(ButtonStyle, __assign({ role: "button", "aria-pressed": "true", onClick: handleClick }, { children: children }), void 0));
};
Button.displayName = 'NekoButton';
var templateObject_1;
